import React from "react";
import PropTypes from "prop-types";
import { Prompt } from "react-router-dom";
import { PHASES } from "@brewery/services/fermentationOrchestrator";
import {
  PHASE_STEPS,
  KEEP_OPEN_COPY,
  LEAVE_WARNING,
  STAGE_NOTE,
} from "@brewery/hooks/useFermentationOrchestrator";

export default function FermentationProgress({
  phase,
  error,
  inFlight,
  retry,
  stopConflictAndRetry,
  handleClose,
}) {
  const steps = PHASE_STEPS;
  const reached =
    phase === PHASES.ERROR
      ? steps.length - 1
      : phase === PHASES.DONE
        ? steps.length
        : steps.findIndex((s) => s.phase === phase);

  return (
    <div className="ferm-progress">
      {steps.map((step, i) => (
        <div
          key={step.phase}
          className={i <= reached ? "step step--done" : "step"}
        >
          {i < reached || phase === PHASES.DONE
            ? "✅"
            : i === reached && phase !== PHASES.ERROR
              ? "🔄"
              : "○"}{" "}
          {step.label}
        </div>
      ))}
      <Prompt when={inFlight} message={LEAVE_WARNING} />
      {inFlight && (
        <div className="ferm-keep-open" role="alert">
          {KEEP_OPEN_COPY}{" "}
          <span className="ferm-keep-open__mobile">
            On a phone, stay on this screen — backgrounding the browser pauses
            it.
          </span>
        </div>
      )}
      {phase === PHASES.DONE && (
        <div className="ferm-stage-note">{STAGE_NOTE}</div>
      )}
      {phase === PHASES.ERROR && (
        <div className="ferm-error">
          <p>{(error && error.message) || "The keg did not respond."}</p>
          {error && error.kind === "session-conflict" && (
            <button
              type="button"
              className="btn btn-primary ferm-stop-conflict"
              onClick={stopConflictAndRetry}
            >
              Stop conflicting fermentation &amp; retry
            </button>
          )}
          <button type="button" className="btn" onClick={retry}>
            Retry
          </button>
        </div>
      )}
      {phase === PHASES.DONE && (
        <button type="button" className="btn btn-primary" onClick={handleClose}>
          Close
        </button>
      )}
    </div>
  );
}

FermentationProgress.propTypes = {
  phase: PropTypes.string,
  error: PropTypes.shape({
    message: PropTypes.string,
    kind: PropTypes.string,
  }),
  inFlight: PropTypes.bool,
  retry: PropTypes.func.isRequired,
  stopConflictAndRetry: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
